//Ticket-Page
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./TicketPage.css";
import Loader from "../../components/helpers/Loader";

const TicketPage = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const navigate = useNavigate();

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    try {
      // const token = localStorage.getItem("token");
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/support/all-tickets`, {

        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      });
      console.log("Fetched tickets:", response.data);
      setTickets(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching tickets:", err);
      setError(err.message || "Failed to fetch tickets");
      setLoading(false);
    }
  };

  const getFilteredTickets = () => {
    if (statusFilter === "all") return tickets;
    return tickets.filter((ticket) => {
      const ticketStatus = ticket.status.toLowerCase().replace(/\s+/g, '-');
      return ticketStatus === statusFilter;
    });
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleTicketClick = (ticket) => {
    navigate(`/ticket/${ticket._id}`, { state: { ticketData: ticket } });
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Loader size={40} color="#4A90E2" secondaryColor="#F3F3F3" />
      </div>
    );
  }

  // if (error) {
  //   return (
  //     <div className="error-container">
  //       <p>Error: {error}</p>
  //       <button onClick={fetchTickets}>Try Again</button>
  //     </div>
  //   );
  // }

  return (
    <div className="ticket-page">
      <div className="ticket-header">
        <h2>Ticket Management</h2>
        <div className="ticket-filters">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">All Status</option>
            <option value="open">Open</option>
            <option value="in-progress">In Progress</option>
            <option value="resolved">Resolved</option>
            <option value="closed">Closed</option>
          </select>
        </div>
      </div>

      <div className="ticket-table">
        <table>
          <thead>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Description</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {getFilteredTickets().length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">
                  No tickets found for {statusFilter === 'all' ? 'any status' : statusFilter} status
                </td>
              </tr>
            ) : (
              getFilteredTickets().map((ticket) => (
                <tr key={ticket._id || ticket.id}>
                  <td>
                    <span
                      className="clickable-user"
                      onClick={() => handleTicketClick(ticket)}
                      title="Click to view ticket details"
                    >
                      {ticket.name}
                    </span>
                  </td>
                  <td>{ticket.email}</td>
                  <td>{ticket.description}</td>
                  <td>
                    <span
                      //className={`ticket-status-badge ${ticket.status.toLowerCase()}`}
                      className={`ticket-status-badge ${ticket.status.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {ticket.status}
                    </span>
                  </td>
                  <td>{formatDate(ticket.createdAt)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TicketPage;
